import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toast-container',
  imports: [CommonModule],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToastContainerComponent {
 // toastSvc = inject(ToastService);        // exposed to template

 public console = console;

  constructor(public toastSvc: ToastService) {}

  dismiss(id: number) {
    this.toastSvc.dismiss(id);
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success': return '✔️';
      case 'warning': return '⚠️';
      case 'error': return '❌';
      case 'info': return 'ℹ️';
      default: return '🔔';
    }
  }

getDefaultIcon(type: string): string {
  switch (type) {
    case 'success': return 'images/AlertIcons/info-icon.svg';
    case 'warning': return 'images/AlertIcons/warning-icon.svg';
    case 'error': return 'images/AlertIcons/danger-icon.svg';
    case 'info': return 'images/AlertIcons/info-icon.svg';
    default: return 'images/AlertIcons/info-icon.sv';
  }
}


}
